import styled from "styled-components";

//components
import BodyText from "core/BodyText";
import Flexbox from "core/Flexbox";

//styles
import colors from "core/colors";
import { rapidEasing, easingSeconds } from "core/animation";

//helpers
import { convertPxToRem } from "frontend/components/helpers";
import { getLinkElementStyles } from "core/Link/styles";

// reusable constant:
const HEIGHT_REM = convertPxToRem({ px: 70 });

// styled components:
export const ContainerFlexbox = styled(Flexbox)`
    overflow: hidden;
`;

export const MoreFromThisTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: flex-start;
    align-items: flex-start;
`;

export const RowHeading = styled(BodyText)`
    width: ${convertPxToRem({ px: 95 })};
    height: ${convertPxToRem({ px: 50 })};
`;

export const ViewAllLink = styled.a`
    ${getLinkElementStyles({
        styleType: "primary",
        size: "lg"
    })}
`;

export const ImageRowWrapper = styled.div`
    display: inline-block;
    width: 100%;
    margin-left: ${convertPxToRem({ px: 16 })};
    margin-right: ${convertPxToRem({ px: 16 })};
`;

export const ImageRow = styled.div`
    height: ${HEIGHT_REM};
    overflow-y: hidden;
`;

export const ImageLink = styled.a`
    display: inline-flex;
    position: relative;
    transition: all ${rapidEasing};
    margin-right: ${convertPxToRem({ px: 16 })};

    &:last-of-type {
        margin-right: 0;
    }

    &:before {
        content: "";
        transition: all ${rapidEasing};
    }

    &:focus {
        outline: none;
        box-shadow: none;

        &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: ${HEIGHT_REM};
            box-shadow: inset 0 0 0 3px ${colors.functional.secondary.parrot};
        }
    }
`;

export const ImageIcon = styled.img`
    display: inline-block;
    opacity: 1;
    transition: opacity ${easingSeconds};
    height: ${HEIGHT_REM};
    width: auto;
    max-width: 100%;
    overflow: hidden;
    pointer-events: none; // protects against right-click-copy

    &:hover {
        opacity: 0.6;
    }
`;
